import * as sjcl from 'sjcl';
import { TranslationKey } from '../../idscan/enums/Translation';
import { ExceptionManager } from './ExceptionManager';

/**
 * Service for encryption of easily visible variables such as token
 *
 * @class SecretService
 *
 * @internal
 */
export class SecretService {
	/**
	 * Encrypt and return the encoded value
	 * @param val
	 */
	public static encrypt = (val: any) => {
		try {
			return Buffer.from(JSON.stringify(sjcl.encrypt(SecretService.secret, JSON.stringify(val)))).toString('base64');
		} catch (e) {
			throw ExceptionManager.process(new ExceptionManager.InvalidParameterException(TranslationKey.EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID));
		}
	}

	/**
	 * Decrypt and return the decoded value
	 * @param val
	 */
	public static decrypt = <T>(val: string = ''): T => {
		let decodedJson;
		try {
			try {
				decodedJson = JSON.parse(Buffer.from(val, 'base64').toString());
			} catch (err) {
				// IEOS-2066 - In case Buffer.from is not supported
				decodedJson = JSON.parse(atob(val));
			}
			return JSON.parse(sjcl.decrypt(SecretService.secret, decodedJson));
		} catch (e) {
			throw ExceptionManager.process(new ExceptionManager.InvalidParameterException(TranslationKey.EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED));
		}
	}

	private static secret: string = 'IDS_FEVER';
}
